import { MapOutlined, TableRowsOutlined } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { BaseDomainType } from '~/common/types';
import { RouteId } from '~/routes/RouteId';

import { SupplierListTab } from './SupplierListTabs.types.ts';

export interface SupplierListTabsProps {
  tab?: SupplierListTab;
  queryId?: string;
}

export const SupplierListTabs = ({ tab, queryId }: SupplierListTabsProps) => {
  return (
    <ToggleButtonGroup value={tab || SupplierListTab.LIST} exclusive>
      <ToggleButton
        component={RouterLink}
        to={RouteId.analyticsBase(BaseDomainType.SUPPLIER, queryId)}
        value={SupplierListTab.LIST}
      >
        <TableRowsOutlined fontSize="small" />
      </ToggleButton>
      <ToggleButton
        component={RouterLink}
        to={RouteId.baseSupplier(SupplierListTab.MAP, queryId)}
        value={SupplierListTab.MAP}
      >
        <MapOutlined fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
